import TestPagePresenter from './TestPagePresenter';

export default function TestPageContainer() {

  return <TestPagePresenter />
}
